import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/services/jwt.service";
import ErrorService from "@/services/errors.service";
import CrawlerService from "./crawler.service";

const ApiAxios = axios.create()

const ApiService = {
  init() {
    this.setupHeaders();

    ApiAxios.interceptors.response.use(function(response) {
      return response;
    }, this.handleError);

    Vue.use(VueAxios, ApiAxios);
  },

  getBaseUrl() {
    return window.location.host == "localhost:8080"
      ? "http://localhost:8000"
      : "/api";
  },

  setupHeaders() {
    ApiAxios.defaults.baseURL = this.getBaseUrl();
    ApiAxios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
    ApiAxios.defaults.headers.common[
      "BranchId"
    ] = `${JwtService.getBranchId()}`;

    CrawlerService.setupHeaders();
  },

  handleError(_error) {
    var error = _error;
    if (_error.response !== undefined) {
      error = _error.response;
    }

    ErrorService.http(error);
    return Promise.reject(error);
  },

  query(_resource, _data) {
    return Vue.axios.get(_resource, { params: _data });
  },

  download(_resource, _slug = "") {
    if (_slug == "") {
      return Vue.axios.get(`${_resource}`, {responseType: 'arraybuffer'});
    } else {
      return Vue.axios.get(`${_resource}/${_slug}`, {responseType: 'arraybuffer'});
    }
  },

  postDownload(_resource, _params) {
    return Vue.axios.post(`${_resource}`, _params, {responseType: 'arraybuffer'});
  },

  get(_resource, _slug = "") {
    if (_slug == "") {
      return Vue.axios.get(`${_resource}`);
    } else {
      return Vue.axios.get(`${_resource}/${_slug}`);
    }
  },

  getAxiosInstance() {
    return ApiAxios;
  },

  post(_resource, _params) {
    return Vue.axios.post(`${_resource}`, _params);
  },

  put(_resource, _id, _params) {
    return Vue.axios.put(`${_resource}/${_id}`, _params);
  },

  patch(_resource, _id, _params) {
    return Vue.axios.patch(`${_resource}/${_id}`, _params);
  },

  delete(_resource, _id) {
    return Vue.axios.delete(`${_resource}/${_id}`);
  }
};

Vue.mixin({
  methods: {
    setupHeaders() {
      ApiService.setupHeaders();
    }
  }
});

export default ApiService;